import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/admin/assets/js/app/utils/events.js